







import { Component, Vue } from 'vue-property-decorator'

import ContractData from '@/components/layouts/Contracts/ContractData.vue'
import Breadcrumbs, { BreadcrumbsItem } from '@/components/lib/Breadcrumbs.vue'

@Component({
  components: {
    ContractData,
    Breadcrumbs,
  },
})
class SubContractInfoView extends Vue {
  breadcrumbsItems: Array<BreadcrumbsItem> = [
    {
      text: 'Сервисы',
      disabled: false,
      to: { name: 'main/maintenances' },
    },
    {
      text: 'Договоры',
      disabled: false,
      to: { name: 'maintenances/contracts' },
    },
    {
      text: this.$route.meta.title,
      disabled: true,
    },
  ]
}

export default SubContractInfoView
